export default {
  fetchLocations(state, payload) {
    state.locationsOptions = payload;
  },
  fetchJournalists(state, payload) {
    state.journalistsOptions = payload;
  },
};